export default __webpack_public_path__ + "static/media/escalera_telescopica.07d99557.png";